import React from 'react';
import styles from './UserActivity.module.css';

const roleLabel = {
    super_admin:  'مشرف عام',
    region_admin: 'مشرف منطقة',
    free_user:    'مستخدم',
};

export default function UserActivity({ data }) {
    return (
        <div className={styles.wrapper}>
            <div>
                <h3 className={styles.subTitle}>أكثر المستخدمين نشاطاً</h3>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>الاسم</th>
                            <th>الدور</th>
                            <th>الإدخالات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.top_users.map((user, idx) => (
                            <tr key={idx}>
                                <td className={styles.rank}>{idx + 1}</td>
                                <td>{user.name}</td>
                                <td>
                                    <span className={`${styles.badge} ${styles[user.role]}`}>
                                        {roleLabel[user.role] || user.role}
                                    </span>
                                </td>
                                <td className={styles.count}>{user.entries}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div>
                <h3 className={styles.subTitle}>النشاط حسب الدور</h3>
                <div className={styles.roleList}>
                    {data.by_role.map((item, idx) => (
                        <div key={idx} className={styles.roleRow}>
                            <span className={`${styles.badge} ${styles[item.role]}`}>
                                {roleLabel[item.role] || item.role}
                            </span>
                            <strong className={styles.roleCount}>{item.entries}</strong>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
